module.exports = __webpack_public_path__ + "img/origins-score.62f05e6e.jpg";